import React from "react";

import { Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

interface NoTargetEmptyCardProps {
  title: string;
  description: string;
}

const NoTargetEmptyCard: React.FC<NoTargetEmptyCardProps> = ({ title, description }) => {
  return (
    <div className="rounded-lg border border-dashed border-gray-300 bg-white px-6 py-4 text-center">
      <Headline size="extra-small" colorType="primary">
        {title}
      </Headline>
      <Paragraph size="medium">{description}</Paragraph>
    </div>
  );
};

export default NoTargetEmptyCard;
